module.exports = __webpack_public_path__ + "img/milkyway.6a0ea244.png";